import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087705.svg";
import buttonArrowIcon from "@assets/images/Frame-91.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import safeIcon from "@assets/icons/safeIcon.svg";
import { HeroBadge } from "@components/ui";
import {
  HeroSection,
  ServicesGridSection,
  CustomSolutionsSection,
  CertifiedSection,
  EmergencyCTASection,
} from "../../components";

export function GasServices() {
  return (
    <div className="w-full flex flex-col items-start justify-center bg-white">
      <HeroSection
        title="Safe, Reliable, and Fully Certified Gas Solutions Across the UAE"
        description="At Gaz Investment in Oil and Gas Supply L.L.C. (GAZ), we design, install, and manage advanced gas systems for residential, commercial, and industrial clients combining safety, efficiency, and smart technology in every connection."
        heroImage={heroImage}
        cta={
          <button className="flex items-center justify-center gap-2.5 py-3 pl-5 pr-2 bg-[#090d2c] rounded-[40px] text-[20px] lg:text-[24px] tracking-[-0.04em] text-white font-albert-sans hover:bg-[#3d405e] transition-colors">
            <span>Request Residential Service</span>
            <img src={buttonArrowIcon} alt="" className="w-10 rounded-full" />
          </button>
        }
        badge={
          <HeroBadge
            text="We provide safe, certified, and efficient gas connections across the UAE, delivered and activated quickly by our licensed technicians."
            linkText="Talk to Our Team"
            icon={<img src={safeIcon} alt="" className="w-7 h-7" />}
          />
        }
      />
      <ServicesGridSection />
      <CustomSolutionsSection />
      <CertifiedSection />
      <EmergencyCTASection
        title="Need Help with your Bill or Account"
        subtitle={
          <>
            Call our 24/7 Emergency Line: 800-GAZ (42747)
            <br />
            or report a concern via our Online Safety Form.
          </>
        }
      >
        <div className="rounded-3xl bg-white flex flex-col items-start p-4 md:p-6 gap-2.5">
          <div className="flex flex-col gap-3 md:gap-5">
            <div className="flex items-center gap-2">
              <div className="flex flex-col gap-3.5">
                <img src={mailIcon} alt="" className="w-4 h-4" />
                <img src={phoneIcon} alt="" className="w-4 h-4" />
              </div>
              <div className="text-[14px] md:text-[16px] tracking-[-0.04em] leading-8 font-medium text-[#20262b] font-albert-sans">
                help@gazglobal.net
                <br />
                Support (8 AM – 8 PM)
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <img src={buildingIcon} alt="" className="w-4 h-4 md:w-5 md:h-5" />
            <span className="text-[14px] md:text-[16px] tracking-[-0.04em] leading-8 font-medium text-[#20262b] font-albert-sans">
              Sunday – Thursday (8 AM – 6 PM)
            </span>
          </div>
        </div>
      </EmergencyCTASection>
      <Footer />
    </div>
  );
}

export default GasServices;
